import { DialogContent as MUIDialogContent, styled } from '@mui/material';

import { lookoDialogHeaderClassName } from './DialogHeader';

/**
 * 모달 헤더.
 */
export default function DialogContent({ children }: { children: React.ReactNode }) {
  return (
    <MUIDialogContent
      sx={{
        px: 4,
        [`.${lookoDialogHeaderClassName} + &`]: {
          paddingTop: 3,
          paddingBottom: 3,
        },
      }}
    >
      {children}
    </MUIDialogContent>
  );
}
